const enabledLocales = ["en-mx", "es-mx", "pt-br"];

const localeConfig = {
  contentfulLocales: enabledLocales.reduce((acc, l) => {
    const parts = l.split("-");
    acc[l] = `${parts[0]}-${parts[1].toUpperCase()}`;

    return acc;
  }, {}),
  enabledLocales,
  nextLocales: ["default", ...enabledLocales],
};

module.exports = localeConfig;
